import React from "react";
import './BracketDisplay.css';
import BracketRound from "./BracketRound";
import {isAllByes} from "utilities/js/bracket/RoundHelper";
import BracketMasthead from "./BracketMasthead";

class BracketDisplay extends React.Component {

    constructor(props){
        super(props);
        this.bracketControlRef = React.createRef();

        this.state = {
        roundToDisplay: 'All'
        };
        
        this.displayAllRounds = this.displayAllRounds.bind(this);
        this.changeRoundToDisplay = this.changeRoundToDisplay.bind(this);
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.contestantMap && prevProps.contestantMap !== this.props.contestantMap){
            this.setState({roundToDisplay: 'All'});
        }
    }


    changeRoundToDisplay(event){
        let round = event.currentTarget.dataset.round;
        this.setState({roundToDisplay: round});
    }

    displayRound(roundNumber){
        let numberOfAllByeRounds = 0;
        let elements = this.props.bracket.map((round, index) => {
            if(isAllByes(round)){
                numberOfAllByeRounds++;
            }
            return (<BracketRound key={index} matchups={round.matchups} bracketRound={round} round={index+1-numberOfAllByeRounds} advanceContestant={this.props.advanceContestant} hideByes={this.props.settings.hideByes} format={this.props.format} individualRound="true" isLocked={this.props.isLocked} contestantMap={this.props.contestantMap} roundSpacing={this.props.settings.roundSpacing}></BracketRound>)
        })
        for(let i = 0; i < numberOfAllByeRounds; i++){
            elements.shift()
        }

        return elements[roundNumber];

    }

    displayAllRounds(){
        let numberOfAllByeRounds = 0;
        let elements = this.props.bracket.map((round, index) => {
            if(isAllByes(round)){
                numberOfAllByeRounds++;
            }
            return (<BracketRound key={index} matchups={round.matchups} bracketRound={round} round={index+1-numberOfAllByeRounds} advanceContestant={this.props.advanceContestant} hideByes={this.props.settings?.hideByes} format={this.props.format} isLocked={this.props.isLocked} contestantMap={this.props.contestantMap} roundSpacing={this.props.settings?.roundSpacing}></BracketRound>)
        })

        for(let i = 0; i < numberOfAllByeRounds; i++){
            elements.shift()
        }
        return elements;
    }

    
    get header(){
        // if(this.props.header){
            return (<BracketMasthead 
                bracketRecord={this.props.bracketRecord} 
                bracket={this.props.bracket} 
                isLocked={this.props.isLocked} 
                header={this.props.header} 
                onSettings={this.props.onSettings} 
                onPublishClick={this.props.onPublishClick} 
                onSettingsClick={this.props.onSettingsClick} 
                onReset={this.props.onReset} 
                onRoundSelect={this.changeRoundToDisplay}
            ></BracketMasthead>)
        // }
        return (<div></div>);
    }

    render(){
        let bracketMarkup;
        if(this.state.roundToDisplay === 'All'){
            bracketMarkup = this.displayAllRounds();
        }else{
            bracketMarkup = this.displayRound(this.state.roundToDisplay);
        }

        return (
            <section id="bracket">
                {this.header}
                <div className="container">
                    <div className="split split-one">
                        {bracketMarkup}
                    </div>
                </div>
            </section>
        );
    }
}

export default BracketDisplay;
